import { ModelType } from '/@/modules/core/app/constants/ModelType';
import { ArtJewelryType } from '@/modules/asset/enums/ArtJewelryType';
import { FinalTaxesAsset } from '@/modules/tax/models/finaltaxescalculator/FinalTaxesAsset';

export class FinalTaxesArtValuableAsset extends FinalTaxesAsset {
  type?: string;
  marketValue?: number;
  purchasePrice?: number;
  rollOver?: boolean;

  constructor(model: Partial<FinalTaxesArtValuableAsset> = {}) {
    super(model);

    this.type = model.type ?? '';
    this.marketValue = model.marketValue ?? 0;
    this.purchasePrice = model.purchasePrice ?? 0;
    this.rollOver = model.rollOver ?? false;
  }

  getModelName(): ModelType {
    return ModelType.FINAL_TAXES_ART_VALUABLE_ASSET;
  }

  get formattedType(): string {
    return ArtJewelryType.getByKey(this.type)?.value ?? '';
  }
}
